import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPaymentTerms } from '@/clients/order/order';

export const usePaymentTerms = () => {
    const { getPaymentTerms } = useGetPaymentTerms();
    return useSuspenseQuery({
        queryKey: ['paymentTerms'],
        queryFn: () => getPaymentTerms(),
        refetchOnWindowFocus: false,
    });
};

export const usePaymentTermsWithoutMarket = () => {
    const { getPaymentTerms } = useGetPaymentTerms();
    return useSuspenseQuery({
        queryKey: ['paymentTerms'],
        queryFn: () => getPaymentTerms(),
        refetchOnWindowFocus: false,
        select: data => data.paymentTerms || [],
    });
};
